<div class="activity-reminder-container">

  
    <mat-nav-list class="activity-actions">
      <a mat-list-item (click)="addActivity($event)" class="primary-action">
        <span matListItemTitle>Create Activity Now</span>
        <span matListItemLine>Add a follow-up task or appointment</span>
      </a>
  

      <a mat-list-item (click)="skipActivity($event)">
        <span matListItemTitle>Skip This Time</span>
        <span matListItemLine>No activity needed</span>
      </a>
    </mat-nav-list>
  </div>